import { Container, Modal, Segment } from 'semantic-ui-react'
import { Logo, ProgressBar } from '../atoms'
import { MarkupText } from 'preact-i18n'
import { useStore } from '../../store/useStore'
import { Show } from '../directives'

const LoadingModal = () => {
  const store = useStore()
  const isSDKLoading = store.initialOptionsStore.isSDKLoading.value
  const open = isSDKLoading
  return (
    <Modal id="loading-modal" basic open={open}>
      <Modal.Content>
        <Container text textAlign="center">
          <Segment inverted style={{ background: 'transparent' }}>
            <Logo animated={false} />
          </Segment>
          <Show when={isSDKLoading}>
            <ProgressBar
              label={
                <span style={{ fontSize: '.85rem' }}>
                  {' '}
                  <MarkupText id="info.loading" />
                </span>
              }
              value={store.loadingStore.percentage.value}
              max={100}
            />
          </Show>
        </Container>
      </Modal.Content>
    </Modal>
  )
}
export default LoadingModal
